import Homepage from "./pages/Homepage";

const App = () => {
  return (
    <div className="w-full">
      <Homepage />
    </div>
  );
};

export default App;
